import { createContext } from 'react'

import { FeatureFlagsContextType } from '../types'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const FeatureFlagsContext = createContext<FeatureFlagsContextType<any>>({
  initialized: false,
  getFeatureValue() {
    return undefined
  },
  inExperiment() {
    return undefined
  },
})
